import script from "./AiCheckDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckDialog.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckDialog.vue?vue&type=style&index=0&id=5b9edea8&lang=css"

const __exports__ = script;

export default __exports__